import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ApplyPage from "@/pages/ApplyPage";

export const Route = createFileRoute("/apply")({
  head: () => pageHead("Apply to Join | AI Innovation Network", "Join the AI Innovation Network. Whether you're an individual AI professional or representing an organization, apply to connect with our community.", "/apply", false),
  component: ApplyPage,
});
